import "bootstrap/dist/css/bootstrap.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { unregister as unregisterServiceWorker } from "./registerServiceWorker";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");
console.log(process.env.NODE_ENV);
ReactDOM.render(
    <BrowserRouter basename={baseUrl}>
        <App />
    </BrowserRouter>,
    rootElement,
);

// The CRA service worker aggressively caches JS/CSS in production, which
// makes deployed UI updates appear broken/stale until the second visit.
// Unregister it (and its caches) so users always get the current build.
unregisterServiceWorker();
